const AppConstants = {
  install(vue) {
    vue.prototype.$loginRequest = {
      account: null,
      scopes: ["openid", "profile", "User.Read"]
    };
    vue.prototype.$graphConfig = {
      graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
      graphGroupsEndpoint: "https://graph.microsoft.com/v1.0/me/memberOf",
      graphMailEndpoint: "https://graph.microsoft.com/v1.0/me/messages"
    };
    vue.prototype.$tokenRequest = {
      account: null,
      scopes: ["api://70e0d248-353e-47f4-816e-fb6a98146ea2/full.access"],
      forceRefresh: false
    };
  }
};
export default AppConstants;
